'use client'

import { Button, Heading, Paragraph } from '@graftcode/design-system'

import { EMAIL_NOT_CONFIRMED_PAGE_TEST_IDS } from '@common/common-test-ids.const'
import { AUTH_LOGOUT_PATH } from '@common/core.const'

import { useRefreshEmailVerification } from '../../hooks/useRefreshEmailVerification'

import styles from './EmailNotConfirmedPage.module.scss'

export function EmailNotConfirmedPage() {
  const { isChecking } = useRefreshEmailVerification()

  const handleLogout = () => {
    window.location.href = AUTH_LOGOUT_PATH
  }

  if (isChecking) {
    return (
      <main className={styles.page} data-testid={EMAIL_NOT_CONFIRMED_PAGE_TEST_IDS.root}>
        <div className={styles.spinner} />
      </main>
    )
  }

  return (
    <main className={styles.page} data-testid={EMAIL_NOT_CONFIRMED_PAGE_TEST_IDS.root}>
      <div className={styles.content}>
        <Heading type="h3">Confirm your email</Heading>
        <Paragraph size="l">
          Your account is signed in, but your email address is not confirmed yet. Please open your inbox and click the
          verification link, then return to this tab.
        </Paragraph>
        <div className={styles.action}>
          <Button size="l" variant="outlined" text="Logout" onClick={handleLogout} />
        </div>
      </div>
    </main>
  )
}
